// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Footer_wrap__cnW1w","inner":"Footer_inner__qDAuE","c2":"Footer_c2__Dy_io","a2":"Footer_a2__Zacio","a23":"Footer_a23__QuYL2"};